import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Confirmation Dialog Component
 *
 * A styled confirmation modal that replaces browser confirm dialogs
 * Provides consistent UX with the rest of the application
 */
import { AlertTriangle, X } from 'lucide-react';
import { Button } from '../ui/button';
export function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', variant = 'warning', isLoading = false, }) {
    if (!open)
        return null;
    const variantConfig = {
        danger: {
            iconBg: 'bg-red-100',
            iconColor: 'text-red-600',
            buttonClass: 'bg-red-600 hover:bg-red-700',
        },
        warning: {
            iconBg: 'bg-yellow-100',
            iconColor: 'text-yellow-600',
            buttonClass: 'bg-yellow-600 hover:bg-yellow-700',
        },
        info: {
            iconBg: 'bg-blue-100',
            iconColor: 'text-blue-600',
            buttonClass: 'bg-blue-600 hover:bg-blue-700',
        },
    };
    const config = variantConfig[variant];
    return (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4", children: _jsxs("div", { className: "relative w-full max-w-md rounded-lg bg-white shadow-xl", children: [_jsx("button", { onClick: onClose, disabled: isLoading, className: "absolute right-4 top-4 rounded-lg p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50", children: _jsx(X, { className: "h-5 w-5" }) }), _jsxs("div", { className: "p-6", children: [_jsx("div", { className: "flex items-center justify-center", children: _jsx("div", { className: `rounded-full p-3 ${config.iconBg}`, children: _jsx(AlertTriangle, { className: `h-6 w-6 ${config.iconColor}` }) }) }), _jsxs("div", { className: "mt-4 text-center", children: [_jsx("h3", { className: "text-lg font-semibold text-gray-900", children: title }), _jsx("p", { className: "mt-2 text-sm text-gray-600", children: message })] }), _jsxs("div", { className: "mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-center", children: [_jsx(Button, { variant: "outline", onClick: onClose, disabled: isLoading, className: "w-full sm:w-auto", children: cancelLabel }), _jsx(Button, { onClick: onConfirm, disabled: isLoading, className: `w-full sm:w-auto ${config.buttonClass} text-white disabled:opacity-50`, children: isLoading ? 'Processing...' : confirmLabel })] })] })] }) }));
}
